export var mobileMaxWidth = 623;
export var tabletMinWidth = 624;
export var tabletMaxWidth = 1020;
export var desktopMinWidth = 1021;
export var desktopMaxWidth = 1440;
export default (() => ({
  global: {
    lrgDesktopMinWidth: '1441px',
    desktopMaxWidth: "".concat(desktopMaxWidth, "px"),
    desktopMinWidth: "".concat(desktopMinWidth, "px"),
    tabletMaxWidth: "".concat(tabletMaxWidth, "px"),
    tabletMinWidth: "".concat(tabletMinWidth, "px"),
    mobileMaxWidth: "".concat(mobileMaxWidth, "px"),
    mobileMinWidth: '0px',
    pageBodyWidth: '1020px'
  }
}));